import { CalendarClock } from 'lucide-react';
import { daysUntilIso } from '@/lib/tasks';
import { cn } from '@/lib/utils';

/** Prazo relativo e colorido: atrasado (vermelho), até 2 dias (âmbar). */
export function TaskDue({
  iso,
  done,
  className,
  icon = true,
}: {
  iso: string | null;
  done?: boolean;
  className?: string;
  icon?: boolean;
}) {
  if (!iso) return null;
  const d = daysUntilIso(iso)!;
  const late = !done && d < 0;
  const soon = !done && d >= 0 && d <= 2;
  const label =
    d === 0
      ? 'Hoje'
      : d === 1
        ? 'Amanhã'
        : d === -1
          ? 'Ontem'
          : new Date(iso).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' }).replace('.', '');
  return (
    <span
      className={cn(
        'tabular inline-flex items-center gap-1 text-[12px] whitespace-nowrap',
        late ? 'text-danger' : soon ? 'text-warning' : 'text-fg-muted',
        done && 'text-fg-subtle',
        className,
      )}
    >
      {icon && <CalendarClock className="size-3.5" />}
      {label}
    </span>
  );
}
